import React, { useRef, useLayoutEffect, useState } from 'react'
import Button from '../../Button'
import { FormContext } from '../context'
import type { FormValues } from '..'
import Loader from '../../Loader'

interface ISubmitButtonProps {
  fullWidth?: boolean
  children: React.ReactNode
  onClick?: (form: FormValues) => void
  isLoading?: boolean
}

const SubmitButton = ({ children, fullWidth, onClick, isLoading = false }: ISubmitButtonProps) => {
  const { form } = React.useContext(FormContext)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const [buttonWidth, setButtonWidth] = useState<number | undefined>(undefined)

  useLayoutEffect(() => {
    if (!isLoading && buttonRef.current) {
      const width = buttonRef.current.offsetWidth
      setButtonWidth(width)
    }
  }, [isLoading, children])

  const isDisabled = isLoading || !!form.isSubmitting

  return (
    <Button
      ref={buttonRef}
      type="submit"
      variant="filled-rounded"
      size="large"
      fullWidth={fullWidth}
      onClick={() => onClick?.(form)}
      disabled={isDisabled}
      style={
        isLoading && buttonWidth
          ? ({
              '--button-width': `${buttonWidth}px`,
              width: 'var(--button-width)',
              minWidth: 'var(--button-width)',
            } as React.CSSProperties)
          : undefined
      }
    >
      {isLoading ? <Loader.Spinner iconOnly /> : children}
    </Button>
  )
}

SubmitButton.displayName = 'Form.SubmitButton'
export default SubmitButton
